// app/components/mainModalContent.jsx
import { ChevronUpIcon } from '@heroicons/react/24/outline'
import SocialIcons from '../components/socialIcons'
import { Link } from '@remix-run/react'

const MainModalContent = ({ setModalContent, page }) => {
  const handleSelection = (selection) => {
    setModalContent(selection)
  }

  return (
    <div className="flex flex-col lg:flex-row">
      <div className="w-full lg:w-1/2 p-4">
        <h2 className="text-headline lg:text-display-md font-bold lg:mb-6">WE ARE WAITING TO HEAR FROM YOU!</h2>
        <div className="hidden lg:flex space-x-4 mb-6">
          <SocialIcons iconColor="text-pointed" iconHover="" iconSize="" />
        </div>
      </div>
      <div className="w-full lg:w-1/2 p-6">
        <div className="space-y-4">
          <p className="font-bold">I want to...</p>
          {page === 'employer' ? (
            <>
              <button
                onClick={() => handleSelection('employer')}
                className="group w-full text-left flex items-center justify-between px-6 py-4 border rounded-[1rem] shadow-sm hover:bg-gray-50"
              >
                Find talent for my company
                <ChevronUpIcon className="rotate-45 w-6 mr-2 pb-[6px] transform transition-transform duration-300 group-hover:text-pointed group-hover:rotate-90 group-hover:pb-[-6px]" />
              </button>
              <button
                onClick={() => handleSelection('jobseeker')}
                className="group w-full text-left flex items-center justify-between px-6 py-4 border rounded-[1rem] shadow-sm hover:bg-gray-50"
              >
                Find a job in Canada
                <ChevronUpIcon className="rotate-45 w-6 mr-2 pb-[6px] transform transition-transform duration-300 group-hover:text-pointed group-hover:rotate-90 group-hover:pb-[-6px]" />
              </button>
            </>
          ) : (
            <>
              <button
                onClick={() => handleSelection('jobseeker')}
                className="group w-full text-left flex items-center justify-between px-6 py-4 border rounded-[1rem] shadow-sm hover:bg-gray-50"
              >
                Find a job in Canada
                <ChevronUpIcon className="rotate-45 w-6 mr-2 pb-[6px] transform transition-transform duration-300 group-hover:text-pointed group-hover:rotate-90 group-hover:pb-[-6px]" />
              </button>
              <button
                onClick={() => handleSelection('employer')}
                className="group w-full text-left flex items-center justify-between px-6 py-4 border rounded-[1rem] shadow-sm hover:bg-gray-50"
              >
                Find talent for my company
                <ChevronUpIcon className="rotate-45 w-6 mr-2 pb-[6px] transform transition-transform duration-300 group-hover:text-pointed group-hover:rotate-90 group-hover:pb-[-6px]" />
              </button>
            </>
          )}
          <Link
            to="#donate"
            preventScrollReset
            className="group w-full text-left flex items-center justify-between px-6 py-4 border rounded-[1rem] shadow-sm hover:bg-gray-50"
          >
            Make a donation
            <ChevronUpIcon className="rotate-45 w-6 mr-2 pb-[6px] transform transition-transform duration-300 group-hover:text-pointed group-hover:rotate-90 group-hover:pb-[-6px]" />
          </Link>
          <button
            onClick={() => handleSelection('partner')}
            className="group w-full text-left flex items-center justify-between px-6 py-4 border rounded-[1rem] shadow-sm hover:bg-gray-50"
          >
            Support TalentLift's work
            <ChevronUpIcon className="rotate-45 w-6 mr-2 pb-[6px] transform transition-transform duration-300 group-hover:text-pointed group-hover:rotate-90 group-hover:pb-[-6px]" />
          </button>
        </div>
      </div>
    </div>
  )
}

export default MainModalContent
